import { Box, Text } from '@factorialco/deprecated-design-system'
import { PerformanceInsightsQuantityEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { InsightsInfoDot } from 'modules/performance_process/components/insights/InfoDot'

export const scoreTranslations = (quality: PerformanceInsightsQuantityEnum): string => {
  switch (quality) {
    case 'high':
      return i18n.t('performance_process.insights.alignment.high')
    case 'normal':
      return i18n.t('performance_process.insights.alignment.normal')
    case 'low':
      return i18n.t('performance_process.insights.alignment.low')
    default:
      const _exhaustiveCheck: never = quality
      throw new Error(`Unhandled quality: ${_exhaustiveCheck}`)
  }
}

export const Insight: React.FC<{
  name?: string
  value?: PerformanceInsightsQuantityEnum | null
  count?: number
}> = ({ name, value, count }) => {
  return (
    <Box flexDirection="column" paddingRight="s12" flexGrow>
      {name && (
        <Text size="200" weight="medium">
          {name}
        </Text>
      )}
      {count ? (
        <Box flexDirection="row" alignItems="center">
          <Text size="300" weight="medium">
            {count}
          </Text>
        </Box>
      ) : value ? (
        <Box flexDirection="row" alignItems="center">
          <Box>
            <InsightsInfoDot value={value} />
          </Box>
          <Box paddingLeft="s8" paddingRight="s16">
            <Text size="300" weight="medium">
              {scoreTranslations(value)}
            </Text>
          </Box>
        </Box>
      ) : (
        <Text size="300" color="grey600">
          {i18n.t('performance_process.insights.no_data')}
        </Text>
      )}
    </Box>
  )
}
